import Button from "../ui/Button/styled";
import H4 from "../ui/Typography/Headings/H4/styled";
import { HOME_PATH } from "../../../constants/RoutesConstants";
import Icon from "../ui/Icon";
import React from "react";
import styled from "styled-components";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";
import { useHistory } from "react-router";
//import useHistoryPush from "../../../hooks/useHistoryPush";

const BackButton: React.FC = () => {
    const history = useHistory();
    //const push = useHistoryPush(HOME_PATH);
    const { appTitle } = useAppTitle();
    if (history.location.pathname === HOME_PATH) {
        return null;
    }
    return (
        <>
            <Styled primary onClick={() => history.goBack()}>
                <Icon name="back" />
            </Styled>
            {/*<Logo onClick={() => push()} />*/}
            <Title>{appTitle}</Title>
        </>
    );
};

export default BackButton;

const Styled = styled(Button as any)`
    font-size: 1.5rem;
    line-height: 2.9rem;
    text-align: left;
`;

const Title = styled(H4 as any)`
    line-height: 2.3rem;
    font-weight: 100;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

/*const Logo = styled.button`
    background-image: url("https://fulltummyfund.co.za/wp-content/uploads/2017/01/PlaceholderLogo.png");
    width: 2.3rem;
    height: 2.3rem;
    border: none;
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 1rem;
    outline: none;
    cursor: pointer;
`;*/
